import type { EngagementTileData } from '@/components/contacts/EngagementTile'

export const portalDashboardKeys = [
  'spend',
  'event_registrations',
  'courses_completed',
  'roster',
  'personal_memberships',
  'groups',
] as const
export type PortalDashboardKey = (typeof portalDashboardKeys)[number]
export type PortalDashboardTile = Omit<EngagementTileData, 'key' | 'secondary_lines'> & {
  key: PortalDashboardKey
}
export interface PortalDashboardResponse {
  dashboard: {
    window: { kind: string; label: string }
    lapsed_banner: string | null
    tiles: PortalDashboardTile[]
    // People with a live Affiliation today; the portal's People tile shows it in place of the
    // Roster filled figure. The staff preview leaves it out with the Roster filled tile when the
    // staff member's Staff Roles hide that tile (#3159).
    people_count?: number
  }
}

export function portalDashboardTile(
  tile: PortalDashboardTile,
  peopleCount: number | undefined,
): PortalDashboardTile {
  if (tile.key !== 'roster' || peopleCount === undefined) return tile
  return {
    ...tile,
    label: 'People',
    figure: String(peopleCount),
    comparison: null,
    direction: 'none',
  }
}
